import { type ChangeEvent, useCallback, useMemo, useState } from 'react';

import debounce from 'lodash/debounce';

const useDebounce = (delay = 500) => {
  const [debounceValue, setDebounceValue] = useState<string>();

  const changeHandler = (value: string) => setDebounceValue(value);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  const debouncedChangeHandler = useMemo(
    () => debounce(changeHandler, delay),
    [delay],
  );

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      debouncedChangeHandler(event.target.value);
    },
    [debouncedChangeHandler],
  );

  const handleStringChange = useCallback(
    (event: string) => {
      debouncedChangeHandler(event);
    },
    [debouncedChangeHandler],
  );

  return { debounceValue, handleChange, handleStringChange };
};

export default useDebounce;
